// extracted by mini-css-extract-plugin
export default {"container":"HomeCharacters_container__-qvMl","navCharacters":"HomeCharacters_navCharacters__lRtB2"};